module.exports = __webpack_public_path__ + "img/c06_unittecharithmetic_Normal_ua.aa24d074.webp";